export default {
  title: 'Proper Disclosure for Pension Marketing',
  content: `
    <p>
      Polaris Pension Insurance Agency (2018) Ltd. is a
      privately owned insurance agency that maintains business relationships with the institutional bodies listed below.
      For the purpose of marketing pension products, there exists an affiliation, as defined in the Control of Financial Services
      (Pension Advice and Pension Marketing) Law, 5765-2005, between Polaris Pension Insurance Agency
      (2018) Ltd. and these bodies and the pension products it markets, in exchange for consideration.
    </p>

    <p>
      <h3>Insurance Companies</h3>
      Clal Pension and Provident Ltd., Menora Mivtachim Pension Ltd., Harel Pension Fund Management Ltd.,
      Migdal Makefet Pension and Provident Funds Ltd., The Phoenix Pension and Provident Ltd.,
      Meitav Dash Provident and Pension Ltd.*, Altshuler Shaham Provident Funds Ltd.*, Psagot Pension and Provident Ltd.*,
    </p>

    <p>
      <h3>Pension Funds</h3>
      Clal Pension and Provident Ltd., Menora Mivtachim Pension Ltd., Harel Pension Fund Management Ltd.,
      Migdal Makefet Pension and Provident Funds Ltd., The Phoenix Pension and Provident Ltd.,
      Meitav Dash Provident and Pension Ltd.*, Altshuler Shaham Provident Funds Ltd.*, Psagot Pension and Provident Ltd.*,
    </p>

    <p>
      <h3>Provident Funds</h3>
      Clal Pension and Provident Ltd., Meitav Dash Provident and Pension Ltd., Psagot Pension and Provident Ltd.,
      The Phoenix-Excellence Nessuah Provident and Pension Ltd., Yelin Lapidot Provident Funds Management Ltd.,
      Altshuler Shaham Provident Funds Ltd., Menora Mivtachim Provident Ltd., Harel Provident and Education Funds Ltd.,
      Migdal Makefet Pension and Provident Funds Ltd., Mor Provident Funds Ltd.
    </p>

    <p>
      <h3>Advanced Study Funds</h3>
      Clal Pension and Provident Ltd., Meitav Dash Provident and Pension Ltd., Yelin Lapidot Provident Funds
      Management Ltd., Altshuler Shaham Provident Funds Ltd., The Phoenix-Excellence Nessuah Provident and Pension
      Ltd., Migdal Makefet Pension and Provident Funds Ltd., Psagot Pension and Provident Ltd.,
      Harel Provident and Education Funds Ltd., Mor Provident Funds Ltd., Menora Mivtachim Provident Ltd.
    </p>
  `,
};
